import { routes } from '@metmuseum/routes';
import NoImage from 'assets/icons/no-image.svg';
import styles from './object-as-archival-label.module.scss';
import { useState } from 'react';
import ReadMoreWrapper from 'components/containers/read-more-wrapper';
import ExternalLinkButton from 'components/controls/links/external-link-button';
import LegacyOrMarkdownParser from 'components/rich-text/legacy-or-markdown-parser';
import { type IObjectAsLauderArchivalLabel } from '@metmuseum/types';

export const ObjectAsLauderArchivalLabel = ({
	archivalLabel,
}: {
	archivalLabel: IObjectAsLauderArchivalLabel;
}) => {
	const [currentImage, setCurrentImage] = useState(archivalLabel.image);
	const [currentImageAlt, setCurrentImageAlt] = useState(
		archivalLabel?.imageAlt,
	);

	const handleThumbnailClick = (image) => {
		setCurrentImage(image.mainImageUrl);
		setCurrentImageAlt(image.altText);
	};

	return (
		<div className={styles.content}>
			<div className={styles.imageWrapper}>
				{currentImage ? (
					<>
						{/* eslint-disable @next/next/no-img-element */}
						<img alt={currentImageAlt} loading="lazy" src={currentImage} />
						{archivalLabel?.images?.length > 1 && (
							<ul className={styles.thumbnails}>
								{archivalLabel.images.map((image) => {
									return (
										<li key={image.mediaXRefID} className={styles.thumbnail}>
											<img
												alt={image.altText}
												loading="lazy"
												src={image.thumbnailImageUrl}
												onClick={() => {
													handleThumbnailClick(image);
												}}
											/>
										</li>
									);
								})}
							</ul>
						)}
						{/* eslint-enable @next/next/no-img-element */}
					</>
				) : (
					<div className={styles.noImageContainer}>
						<NoImage className={styles.noImageSvg} />
					</div>
				)}
				{/* TODO: we don't care about the primaryImageRestricted of the object. we need to know if the CURRENT image is restricted.
			{/* {object?.primaryImageRestricted && (<RightsRestrictedMessage />)} */}
			</div>
			<div className={styles.textWrapper}>
				<div className={styles.text}>
					<h2 className={styles.title}>
						<LegacyOrMarkdownParser>
							{archivalLabel?.title}
						</LegacyOrMarkdownParser>
					</h2>
					<div className={styles.label}>
						<ReadMoreWrapper maxLines={10}>
							<div>
								<LegacyOrMarkdownParser>
									{archivalLabel.webLabel}
								</LegacyOrMarkdownParser>
							</div>
						</ReadMoreWrapper>
					</div>
					<ExternalLinkButton
						href="/research-centers/leonard-a-lauder-research-center/collections/the-leonard-a-lauder-cubist-collection-at-the-met"
						text={'View The Leonard A. Lauder Cubist Collection'}
					/>{' '}
					:
					<ExternalLinkButton
						text="View Full Object Record"
						href={routes.object(archivalLabel.objectID)}
					/>
				</div>
			</div>
		</div>
	);
};
